import BaseService from './base.service';

class QualityObservationScoreService extends BaseService {
  /**
   * Get score for a quality observation
   * @param {number} observationId - ID of the quality observation
   * @returns {Promise<Object>} - Score data
   */
  getScore(observationId) {
    return this.get(`/quality-observation/${observationId}/score`);
  }

  /**
   * Create or update score for a quality observation
   * @param {number} observationId - ID of the quality observation
   * @param {Object} scoreData - Score data (educationalValue, severityOfIssue, frequencyOfIssue)
   * @returns {Promise<Object>} - Updated score data
   */
  saveScore(observationId, scoreData) {
    return this.post(`/quality-observation/${observationId}/score`, scoreData);
  }

  /**
   * Send score to technologist for a quality observation
   * @param {number} observationId - ID of the quality observation
   * @returns {Promise<Object>} - Response data
   */
  sendScoreToTechnologist(observationId) {
    return this.post(`/quality-observation/${observationId}/evaluation/send`);
  }
}

export default new QualityObservationScoreService();
